module.exports = __webpack_public_path__ + "img/mastercard.3299148.png";